"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCheckoutMissingFields = void 0;
const events_1 = require("../../events");
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
const createEventLabel = (type, missingFields) => `MissingField${type}_${missingFields.join('_')}`;
const createNotificationType = (type, missingFields) => `Missing field ${type} ${missingFields.join(',')}`;
function trackCheckoutMissingFields(errors) {
    if (!errors) {
        return;
    }
    const missingFields = [];
    const eventCategory = enums_1.EventCategory.Cart;
    const eventAction = 'Error';
    const notificationMsg = 'Bitte ergänze oder korrigiere deine Angaben';
    if (errors.email) {
        missingFields.push('email');
    }
    if (errors.phoneNumber) {
        missingFields.push('phoneNumber');
    }
    if (errors.billingAddress) {
        missingFields.push(...Object.keys(errors.billingAddress));
        (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
            eventAction,
            eventCategory,
            eventLabel: createEventLabel(events_1.CheckoutMissingFieldType.BILLING, missingFields),
            eventData: {
                eventName: enums_1.GA4EventName.ShowNotification,
                feature_category: enums_1.GA4FeatureCategory.Cart,
                notification_message: notificationMsg,
                notification_type: createNotificationType(events_1.CheckoutMissingFieldType.BILLING, missingFields),
            },
        });
    }
    else if (errors.email || errors.phoneNumber) {
        (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
            eventAction,
            eventCategory,
            eventLabel: createEventLabel(events_1.CheckoutMissingFieldType.BILLING, missingFields),
            eventData: {
                eventName: enums_1.GA4EventName.ShowNotification,
                feature_category: enums_1.GA4FeatureCategory.Cart,
                notification_message: notificationMsg,
                notification_type: createNotificationType(events_1.CheckoutMissingFieldType.BILLING, missingFields),
            },
        });
    }
    if (errors.shippingAddress) {
        const shippingAddressMissingFields = Object.keys(errors.shippingAddress);
        (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
            eventAction,
            eventCategory,
            eventLabel: createEventLabel(events_1.CheckoutMissingFieldType.DELIVERY, shippingAddressMissingFields),
            eventData: {
                eventName: enums_1.GA4EventName.ShowNotification,
                feature_category: enums_1.GA4FeatureCategory.Cart,
                notification_message: notificationMsg,
                notification_type: createNotificationType(events_1.CheckoutMissingFieldType.DELIVERY, shippingAddressMissingFields),
            },
        });
    }
}
exports.trackCheckoutMissingFields = trackCheckoutMissingFields;
//# sourceMappingURL=trackCheckoutMissingFields.js.map